<template>
    <div class="data-table">
        <h4 v-if="title !== ''" style="text-align: center; font-size: 18px; font-weight: 400">{{ title }}</h4>
        <div style="margin-bottom: 10px">
            <el-row type="flex" class="row-bg" justify="space-between">
                <div style="height: 34px">
                    <slot name="leftTitle" />
                </div>
                <div style="text-align: right; height: 34px">
                    <el-button v-if="isDownload && update" :key="fileName" plain :size="'small'" :file-name="fileName ? lm.title + '-' + fileName : lm.title" @click="print">
                        <i class="el-icon-printer" />
                        打印
                    </el-button>
                    <el-button v-if="isDownload && update" :key="fileName" v-table-toxls="views" plain :size="'small'" :file-name="fileName ? lm.title + '-' + fileName : lm.title">
                        <svg-icon icon-class="export" />
                        导出
                    </el-button>
                </div>
            </el-row>
        </div>
        <div class="teble-div">
            <el-table v-if="!doing" id="views" v-loading="loading" :data="listData" border style="width: 100%" :span-method="spanMethod">
                <el-table-column v-for="(option, optionKey) in tableColumn" :key="optionKey" :prop="option.prop" :label="option.title" :width="option.width" :align="option.align" :show-overflow-tooltip="true" :formatter="option.formatter">
                    <el-table-column v-for="(child, childKey) in option.child" :key="childKey" :prop="child.prop" :label="child.title" :width="child.width" :align="child.align" :show-overflow-tooltip="true" :formatter="child.formatter" />
                </el-table-column>
            </el-table>
            <div v-else class="empty-table">
                <span style="font-size: 30px"><i class="el-icon-loading" /></span>
                <br />
                <span style="font-size: var(--portalFontSize15)">正在加载...</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        title: {
            type: String,
            default: function () {
                return ''
            }
        },
        countkh: {
            type: String,
            default: function () {
                return ''
            }
        },
        tableColumn: {
            type: Array,
            default: function () {
                return []
            }
        }, // 列表头数组
        listData: {
            type: Array,
            default: function () {
                return []
            }
        }, // 表格数据
        getSummaries: {
            type: Function,
            default: function () {
                return true
            }
        }, // 自定义合计行
        sumText: {
            type: String,
            default: function () {
                return '合计'
            }
        }, // 合计标题
        showSummary: {
            type: Boolean,
            default: function () {
                return false
            }
        }, // 是否显示合计
        spanMethod: {
            type: Function,
            default: function () {
                return true
            }
        }, //
        tbToolbar: {
            type: Array,
            default: function () {
                return [{ val: '', name: '' }]
            }
        }, // 多表格切换按钮
        tbToolbarClick: {
            type: Function,
            default: function () {
                return true
            }
        }, // 表格切换点击事件
        fileName: {
            type: String,
            default: function () {
                return ''
            }
        }, // 表格导出标题
        isDownload: {
            type: Boolean,
            default: function () {
                return true
            }
        } // 是否导出
    },
    data() {
        return {
            loading: true,
            toolbarVal: this.tbToolbar.length > 1 ? this.tbToolbar[0].val : '',
            lm: this.$route.meta,
            update: true,
            doing: true
        }
    },
    watch: {
        toolbarVal(val) {
            this.update = false
            this.$nextTick(() => {
                this.update = true
            })
        },
        tableColumn(val) {
            this.doing = false
            setTimeout(() => {
                this.trandClass()
            }, 1000)
        },
        listData(val) {
            this.doing = false
        }
    },
    created() {
        if (this.tbToolbar.length > 1) {
            this.tbToolbar.forEach((item) => {
                if (item.val === this.toolbarVal) {
                    this.fileName = item.name
                }
            })
            this.update = false
            this.$nextTick(() => {
                this.update = true
            })
        }
    },
    mounted() {
        this.loading = false
    },
    methods: {
        trandClass() {
            const table = document.querySelector('.el-table__footer')
            if (table !== null) {
                const trs = table.querySelectorAll('.has-gutter tr')
                if (trs.length > 0) {
                    trs.forEach((tr) => {
                        tr.className = 'el-table__row'
                    })
                }
            }
        },
        print() {
            const printWindow = window.open('', '_blank')
            printWindow.document.write(`  
    <html>  
      <head>  
        <title>中鼎誉润智慧云OA</title>  
        <style>  
          body { font-family: Arial, sans-serif; }  
                table { border-collapse: collapse; width: 100%; }  
                th, td { border: 1px solid #ddd; padding: 8px; }  
                th { background-color: #f2f2f2; }   
        </style>  
      </head>  
      <body>
        <table>  
          <thead>  
            <tr>  
              <th>月份</th>  
              <th>投标数</th>  
              <th>中标数</th>  
              <th>合同总金额（元）</th>  
              <th>合同签订数</th>  
              <th>中标率</th>  
            </tr>  
          </thead>  
          <tbody>  
    ${this.listData
        .map(
            (row) => `  
          <tr>  
            <td style='text-align: left;'>${row.month}</td>  
            <td style='text-align: center;'>${row.tbCount}</td>  
            <td style='text-align: center;'>${row.zbCount}</td>  
            <td style='text-align: right;'>${row.htAmount}</td>  
            <td style='text-align: center;'>${row.htCount}</td>  
            <td style='text-align: center;'>${row.zbTax}</td>  
          </tr>  
        `
        )
        .join('')}
          </tbody>  
        </table>  
      </body>  
    </html>  
  `)
            printWindow.document.close()
            printWindow.onload = function () {
                printWindow.print()
                printWindow.close()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@media print {
    table {
        width: 100%; /* 设置表格宽度为100% */
        border-collapse: collapse; /* 合并边框 */
    }
    th,
    td {
        border: 1px solid #ddd; /* 添加边框 */
        padding: 8px; /* 添加单元格内边距 */
        word-wrap: break-word; /* 自动换行 */
    }
}
.data-table {
    margin-top: 20px;
    .frequency {
        span {
            padding-right: 20px;
            font-size: var(--portalFontSize14);
            font-weight: 600;
        }
    }
    .teble-div {
        position: relative;
        .empty-table {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1000%;
            text-align: center;
        }
    }
}
</style>
